import React, { Component } from 'react';
import theme from 'shared/assets/style/theme';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import ThemeContext from 'shared/context/ThemeContext';
import SLinkAccountForm from 'shared/screens/LinkAccountForm';
import { checkIfOtpRequeridedConsents } from 'shared/screens/OneTimePassword/utils';
import CopySelector from 'shared/utils/copySelector';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import ImageBW from '../../components/ImageBoundsWrapper';
import TermsAndConditions from '../../components/TermsAndConditions';
import FormButton from './components/FormButton';
import FormFooter from './components/FormFooter';
import FormInputs from './components/FormInputs';
import FormSubtitle from './components/FormSubtitle';
import { styles } from './styles';

const PROPERTY_SELECTOR_CONSTANTS = {
  NO_PROPERTY_SELECTED: '',
  GENERIC_PROPERTY: '1',
};
export default class LinkAccountForm extends Component {
  state = {
    formValues: {
      accountNumber: '',
      year: '',
      month: '',
      day: '',
      propertyId: '1',
      pin: '',
    },
    isOpenTerms: false,
    activeOTPCheckbox: false,
    docType: 'TERMS',
  };

  clearError = null;

  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-link-account',
      hideBeforeSelector: ENVIRONMENT_VARIABLES.APPLICATION_TARGET === 'hri',
    };
  }

  handleLinkBtn = handleLinkCallback => {
    handleLinkCallback(this.state.formValues);
  };

  handleInputChange = key => event => {
    this.clearError();
    this.setState(prevState => ({
      formValues: {
        ...prevState.formValues,
        [key]: event.value !== null ? event.value.toString() : '',
      },
    }));
  };

  handleToggleTerms = docType => {
    this.setState(prevState => ({
      isOpenTerms: !prevState.isOpenTerms,
      docType: docType || 'TERMS',
    }));
  };

  handleOPTCheckbox = () => {
    this.setState(prevState => ({
      activeOTPCheckbox: !prevState.activeOTPCheckbox,
    }));
  };

  isPropertySelected = propertyId => {
    return (
      propertyId !== PROPERTY_SELECTOR_CONSTANTS.NO_PROPERTY_SELECTED &&
      propertyId !== PROPERTY_SELECTOR_CONSTANTS.GENERIC_PROPERTY
    );
  };

  render() {
    const themeContext = this.context;
    const {
      formValues: { propertyId },
      isOpenTerms,
    } = this.state;

    return (
      <SLinkAccountForm
        {...this.props}
        render={args => {
          const {
            handleLinkAccount,
            handlePinAndAccount,
            handleRegisterRewardCard,
            success,
            message,
            error,
            termsAndConditionsUrl,
            propertySelector,
            userProperty,
            setPropertyId,
            copys,
            clearError,
            enableOrderCard,
            findSelectedPropertyObject,
          } = args;

          let propertySelected = setPropertyId(userProperty, propertyId);
          const selectedPropertyObj =
            this.isPropertySelected(propertySelected) && findSelectedPropertyObject(propertySelected);

          let selectedPropertyTermsURLs;
          if (selectedPropertyObj) {
            selectedPropertyTermsURLs = {
              termsAndConditions: selectedPropertyObj.loyaltyTermsAndConditions,
              privacyPolicy: selectedPropertyObj.loyaltyPrivacyPolicy,
            };
          }

          this.clearError = clearError;

          return (
            <div style={themeContext.LinkAccountForm.ScreenBackground}>
              <div style={styles.header}>
                <ImageBW
                  source={require(asset`Full_Modal_Header.png`)}
                  ibw={require(asset`Full_Modal_Header.ibw`)}
                  style={themeContext.LinkAccountForm.HeaderImage}
                >
                  {isOpenTerms && (
                    <div style={styles.backArrowContainer} onClick={this.handleToggleTerms}>
                      <ImageBW
                        source={require(asset`Back_Arrow@3x.png`)}
                        ibw={require(asset`Back_Arrow.ibw`)}
                        style={{
                          cursor: 'pointer',
                          objectFit: 'contain',
                        }}
                        alt="Close"
                        widthScale={0.5}
                      />
                    </div>
                  )}
                  <div style={themeContext.LinkAccountForm.HeaderTitle}>
                    <span style={{ textTransform: 'uppercase' }}>
                      {!isOpenTerms
                        ? `${CopySelector.getCopy(CopySelector.COPY_TYPES.LINK_CARD_TITLE, copys)}`
                        : this.state.docType === 'TERMS'
                        ? getText(TEXT_KEY.TERMS_AND_CONDITIONS_TITLE)
                        : getText(TEXT_KEY.PRIVACY_POLICY)}
                    </span>
                  </div>
                </ImageBW>
              </div>
              {!isOpenTerms ? (
                <div className="hidenScrollBar" style={themeContext.LinkAccountForm.FormContainer}>
                  <FormSubtitle />
                  {success && (
                    <p
                      style={{
                        textAlign: 'center',
                        color: theme.palette.success[1],
                      }}
                    >
                      {message}
                    </p>
                  )}
                  {!success && (
                    <>
                      <FormInputs handleInputChange={this.handleInputChange} formValues={this.state.formValues} />
                      {!success && error && (
                        <p
                          style={{
                            textAlign: 'center',
                            color: theme.palette.error[1],
                            paddingTop: 2,
                          }}
                        >
                          {error}
                        </p>
                      )}
                      <FormFooter
                        termsAndConditionsURL={termsAndConditionsUrl}
                        enableOrderCard={selectedPropertyObj ? selectedPropertyObj?.enableOrderCard : enableOrderCard}
                        handleRegisterRewardCard={handleRegisterRewardCard}
                        handleOpenTerms={this.handleToggleTerms}
                        showOTPConsents={
                          selectedPropertyObj?.requiresConsents ||
                          checkIfOtpRequeridedConsents(setPropertyId(userProperty, propertyId), propertySelector)
                        }
                        activeOTPCheckbox={this.state.activeOTPCheckbox}
                        handleOPTCheckbox={this.handleOPTCheckbox}
                        selectedPropertyObj={selectedPropertyObj}
                      />
                      <FormButton
                        handleLinkBtn={this.handleLinkBtn}
                        handleLinkAccount={handleLinkAccount}
                        handlePinAndAccount={handlePinAndAccount}
                        error={error}
                        activeOTPCheckbox={this.state.activeOTPCheckbox}
                        showOTPConsents={
                          selectedPropertyObj?.requiresConsents ||
                          checkIfOtpRequeridedConsents(setPropertyId(userProperty, propertyId), propertySelector)
                        }
                      />
                    </>
                  )}
                </div>
              ) : (
                <div style={styles.termsModal}>
                  <TermsAndConditions docType={this.state.docType} selectedPropertyTerms={selectedPropertyTermsURLs} />
                </div>
              )}
            </div>
          );
        }}
      />
    );
  }
}

LinkAccountForm.contextType = ThemeContext;

